/*
 * @Description:
 * @Autor: yd
 * @Date: 2020-11-18 18:51:12
 * @最后编辑: Please set LastEditors
 * @最后修改时间: 2022-05-05 15:47:09
 */
import Vue from "vue";
import messageVue from "./Message.vue";
const defaults = {
  show: false,
  text: "",
  duration: "3000",
  type: "",
};
const messageVueConstructor = Vue.extend(messageVue);
messageVueConstructor.prototype.close = function () {
  var vm = this;
  this.$on("after-leave", (_) => {
    if (vm.$el && vm.$el.parentNode) {
      vm.$el.parentNode.removeChild(vm.$el);
    }
    this.$destroy();
  });
  vm.show = false;
};
const Message = (options = {}) => {
  if (Vue.prototype.$isServer) return;
  options = Object.assign({}, defaults, options);
  let parent = document.body;
  let instance = new messageVueConstructor({
    el: document.createElement("div"),
    data: options,
  });
  parent.appendChild(instance.$el);
  Vue.nextTick(() => {
    instance.show = true;
    setTimeout(function () {
      instance.close();
    }, options.duration);
  });

  return instance;
};

export default Message;
